// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1004;
  position: sticky;
  top: 0;
}

.custom_header_avatar div div {
  display: flex;
  align-items: center;
}

.notification-alert {
  position: absolute;
  top: -80%;
  right: 0;
  background-color: red;
  height: 10px;
  width: 10px;
  line-height: 10px;
  transform: translate(0px, -10%);
  border-radius: 50%;
}

.notification-message {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: white;
  color: black;
  transform: translate(0px, -3%);
  min-width: 200px;
  padding: 0.5rem;
  border-radius: 10px;
  box-shadow: 6px 7px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/containers/Layout/components/Header/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,MAAA;AACF;;AAII;EACE,aAAA;EACA,mBAAA;AADN;;AAMA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,+BAAA;EACA,kBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,2CAAA;EACA,eAAA;AAHF","sourcesContent":[".custom_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 1004;\n  position: sticky;\n  top: 0;\n}\n\n.custom_header_avatar {\n  div {\n    div {\n      display: flex;\n      align-items: center;\n    }\n  }\n}\n\n.notification-alert {\n  position: absolute;\n  top: -80%;\n  right: 0;\n  background-color: red;\n  height: 10px;\n  width: 10px;\n  line-height: 10px;\n  transform: translate(0px, -10%);\n  border-radius: 50%;\n}\n\n.notification-message {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background-color: white;\n  color: black;\n  transform: translate(0px, -3%);\n  min-width: 200px;\n  padding: 0.5rem;\n  border-radius: 10px;\n  box-shadow: 6px 7px 10px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
